import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { CSSPlugin } from 'gsap/all'

const lib = require('../library')

gsap.registerPlugin(ScrollTrigger, SplitText, ScrollToPlugin, CSSPlugin)

export default class AnimationFeatureIn {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.elmsAni = this.el.querySelectorAll('[data-animate]')
    this.figureAni = this.el.querySelector('[data-animate-figure]')
    this.childAni = this.el.querySelectorAll('[data-animate-child]')
    this.headingAni = this.el.querySelectorAll('[data-animate-heading]')
    this.btnAni = this.el.querySelector('[data-animate-button]')
    this.screen = this.el.querySelector('[data-animate-screen]')
    this.sections = document.querySelectorAll('[ data-section-break]')
    this.nextSectionBtn = this.el.querySelector('[data-animate-next-btn]')
    this.nextSection = false
    this.nextBtnClass = 'anim-beat'
    this.motion = lib.userMotionEnabled()
  }

  init() {
    this.handleRemoveHiddenJs()
    // if the item's top is not below the window height, just render it
    const offset = this.el.getBoundingClientRect()
    if (offset.top < window.outerHeight - 20) {
      console.log('disabled animation')
      this.screen.remove()
      return false
    }

    if (this.nextSectionBtn) {
      this.hideNextButton()
    }
    if (this.motion) {
      this.handleScrollAnimation()
    } else if (this.screen) {
      this.screen.remove()
    }
  }

  handleRemoveHiddenJs() {
    const hidden = this.el.querySelectorAll('.js-init-hidden')
    hidden.forEach((elm) => {
      elm.classList.remove('js-init-hidden')
    })
  }

  hideNextButton() {
    if (this.nextSectionBtn) {
      gsap.set(this.nextSectionBtn, { autoAlpha: 0 })
      this.nextSectionBtn.classList.remove(this.nextBtnClass)
    }
  }

  handleNextButton = () => {
    // check to make sure it's actually loaded
    if (!this.nextSectionBtn) {
      return false
    }
    if (this.sections.length > 0) {
      const index = [...this.sections].indexOf(this.el)
      if (index + 1 < this.sections.length) {
        this.nextSection = this.sections[index + 1]
      }
      this.nextSectionBtn.addEventListener('click', () => {
        gsap.to(window, {
          duration: 0.75,
          scrollTo: this.nextSection,
          ease: 'Power3.easeInOut',
        })
      })
    } else {
      this.nextSectionBtn.remove()
      return false
    }
    // if it is, let's fade it in after a delay
    const tlNext = gsap.timeline()
    if (this.nextSection) {
      tlNext.delay(1)
        .fromTo(
          this.nextSectionBtn,
          {
            autoAlpha: 0,
          },
          {
            autoAlpha: 1,
            stagger: 0.1,
            duration: 0.8,
          },
        )
      // tlNext
      tlNext.eventCallback('onComplete', () => {
        this.nextSectionBtn.classList.add(this.nextBtnClass)
      })
    }
  }

  handleScrollAnimation() {
    let splitFeatureText = ''
    const text = this.childAni

    splitFeatureText = new SplitText(this.headingAni, {
      type: 'lines',
      linesClass: 'relative',
      reduceWhiteSpace: false,
    })
    const splitParent = new SplitText(this.headingAni, {
      linesClass: 'relative overflow-hidden',
      reduceWhiteSpace: false,
    })
    gsap.defaults({
      ease: 'none',
      duration: 1,
    })

    // timeline for text
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
        start: 'top+=10% center',
        end: 'center-=10% center',
        // scrub: 2,
        // toggleActions: 'play none none none',
        onLeave: () =>
          this.hideNextButton(),
        once: true,
      },
    })

    // timeline for image
    const tlImage = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
        start: 'top+=20% center',
        // end: 'center center',
        // scrub: 1.5,
        once: true,
        toggleActions: 'play pause resume none',
      },
    })

    // check to verify image in figure
    const image = this.figureAni.querySelector('img')

    // animate figure fade and image zoom in
    tlImage.fromTo(
      this.figureAni,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
      },
    )
    if (image) {
      tlImage.fromTo(
        image,
        {
          scale: 1.04,
        },
        {
          scale: 1,
        },
        '0',
      )
    }

    tl.from(
      splitFeatureText.lines,
      {
        duration: 1.5,
        yPercent: 100,
        ease: 'power4',
        stagger: 0.2,
      },
      '-=0.2',
    )
    tl.fromTo(
      this.childAni,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        stagger: 0.1,
      },
      '-=1',
    )
    if (this.screen) {
      tl.fromTo(
        this.screen,
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
        },
        '0',
      )
    }
    if (this.btnAni) {
      tl.fromTo(
        this.btnAni,
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
          stagger: 0.1,
        },
        '-=.5',
      )
    }
    tl.eventCallback('onComplete', this.handleNextButton)
  }
}
